export enum CityAction {
    UPDATE_LOADING = "UPDATE_LOADING",
    ADD_CITY_LIST = "ADD_CITY_LIST",
    UPDATE_CITY_LIST = "UPDATE_CITY_LIST",
    UPDATE_CITY_SEARCH_REQ = "UPDATE_CITY_SEARCH_REQ",
    SET_UPDATE_CITY = "SET_UPDATE_CITY",
    UPDATE_COUNTRY_LIST = "UPDATE_COUNTRY_LIST",
}